import React from 'react';
import { InsidePagesCarousel } from '../InsidePagesCarousel';
import { SectionHeading } from './SectionHeading';
export function InsideSection() {
  return <section aria-labelledby="inside-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-20" data-id="element-114" data-mp="2lz7ysq8p4ia3">
      <div className="mx-auto max-w-6xl" data-id="element-115" data-mp="2h424p4553xax">
        <SectionHeading id="inside-heading" title="Découvrez ce que vous allez pouvoir utiliser dans vos cours 👇" body="Des ressources visuelles, pratiques et structurées pour enseigner avec plus de facilité." data-id="element-116" data-mp="2d5mk16wj710o" />

        <div className="mt-12" data-id="element-117" data-mp="238q7mq3ihuqu">
          <InsidePagesCarousel data-id="element-118" data-mp="1y70wlagahh2r" />
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center font-display text-[1.5rem] font-bold leading-snug text-brand-charcoal sm:text-[1.75rem]" data-id="element-119" data-mp="1y7u80oq70ur8">
          Des supports concrets pour passer moins de temps à préparer et plus de temps à enseigner.
        </p>
      </div>
    </section>;
}